import { Component } from "react";
import { ToastContainer } from "react-toastify";
import Loader from "../../../utils/Loader";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu";
import AgentHeader from "../../../common_components/agent_module_header";
import AgentDrawer from "../../../common_components/agent_module_drawer";
import AgentTopMenu from "../../../common_components/agent_module_topmenu";
import { BASE_URL } from "../../../utils/constants";

import "pdfjs-dist/build/pdf.worker.entry";
// import { BASE_URL } from "../../../utils/constants";
import * as pdfjsLib from "pdfjs-dist";

class RulesRegulations extends Component {
    state = {
        isLoading: false,
        pdfBlobUrl: null,
    };

    componentDidMount() {
        // ===== Disable right-click & shortcuts =====
        this.contextMenuHandler = (e) => e.preventDefault();
        document.addEventListener("contextmenu", this.contextMenuHandler);

        this.keyDownHandler = (e) => {
            if (
                e.keyCode === 123 || // F12
                (e.ctrlKey && e.shiftKey && (e.keyCode === 73 || e.keyCode === 74)) || // Ctrl+Shift+I/J
                (e.ctrlKey && e.keyCode === 85) // Ctrl+U
            ) {
                e.preventDefault();
                return false;
            }
        };
        document.addEventListener("keydown", this.keyDownHandler);

        // ===== PDF.js Rendering =====
        const url = `${BASE_URL.split("/api")[0]}${sessionStorage.getItem("RulesAndRegulations")}`;

        const container = document.getElementById("pdf-container");

        pdfjsLib.getDocument(url).promise.then(async (pdf) => {
            for (let i = 1; i <= pdf.numPages; i++) {
                const page = await pdf.getPage(i);
                const viewport = page.getViewport({ scale: 1.5 });

                const canvas = document.createElement("canvas");
                const context = canvas.getContext("2d");

                canvas.height = viewport.height;
                canvas.width = viewport.width;

                // Responsive styling
                canvas.style.width = "60%";
                canvas.style.height = "auto";
                canvas.style.display = "block";
                canvas.style.margin = "20px auto";

                container.appendChild(canvas);

                await page.render({ canvasContext: context, viewport }).promise;
            }
        });

    }

    componentWillUnmount() {
        document.removeEventListener("contextmenu", this.contextMenuHandler);
        document.removeEventListener("keydown", this.keyDownHandler);
    }

    getHeader() {
        const loginData = JSON.parse(sessionStorage.getItem("loginDataSS") || "{}");
        const indirectAgentData = JSON.parse(
            sessionStorage.getItem("indirectAgentloginDataSS") || "{}"
        );
        const isAgentDirect =
            sessionStorage.getItem("IsAgentDirectLogin") === "true";

        if (loginData.RoleID !== 8) {
            if (isAgentDirect)
                return loginData.RoleID === 4 ? (
                    <AgentHeader />
                ) : (
                    <ExhibitorHeader />
                );
            else
                return indirectAgentData.RoleID === 4 ? (
                    <AgentHeader />
                ) : (
                    <ExhibitorHeader />
                );
        }
        return <ExhibitorHeader />;
    }

    getDrawer() {
        const loginData = JSON.parse(sessionStorage.getItem("loginDataSS") || "{}");
        const indirectAgentData = JSON.parse(
            sessionStorage.getItem("indirectAgentloginDataSS") || "{}"
        );
        const isAgentDirect =
            sessionStorage.getItem("IsAgentDirectLogin") === "true";

        if (loginData.RoleID !== 8) {
            if (isAgentDirect)
                return loginData.RoleID === 4 ? (
                    <AgentDrawer />
                ) : (
                    <ExhibitorDrawer />
                );
            else
                return indirectAgentData.RoleID === 4 ? (
                    <AgentDrawer />
                ) : (
                    <ExhibitorDrawer />
                );
        }
        return <ExhibitorDrawer />;
    }

    getTopMenu() {
        const loginData = JSON.parse(sessionStorage.getItem("loginDataSS") || "{}");
        const indirectAgentData = JSON.parse(
            sessionStorage.getItem("indirectAgentloginDataSS") || "{}"
        );
        const isAgentDirect =
            sessionStorage.getItem("IsAgentDirectLogin") === "true";

        if (loginData.RoleID !== 8) {
            if (isAgentDirect)
                return loginData.RoleID === 4 ? (
                    <AgentTopMenu />
                ) : (
                    <ExhibitorTopMenu />
                );
            else
                return indirectAgentData.RoleID === 4 ? (
                    <AgentTopMenu />
                ) : (
                    <ExhibitorTopMenu />
                );
        }
        return <ExhibitorTopMenu />;
    }

    render() {
        const { isLoading } = this.state;
        const exhibitionName =
            sessionStorage.getItem("sessionExhibitionName") || "Exhibition";

        return (
            <>
                {isLoading && <Loader />}
                <ToastContainer />

                {this.getHeader()}
                {this.getDrawer()}

                <div className="page">
                    <div className="page-main">
                        <div className="main-content with-dr-container">
                            <div className="width-dr-nav">
                                <div className="row">{this.getTopMenu()}</div>
                            </div>

                            <div className="row">
                                <div className="col-xl-12 p-0">
                                    <div className="card rounded-0 pt-1 shadow-none">
                                        <div className="card-header p-2">
                                            <h3
                                                className="card-title"
                                                style={{ fontSize: 15 }}
                                            >
                                                Rules and Regulations for {exhibitionName}
                                            </h3>
                                        </div>
                                        <div className="card-body p-1">
                                            <div
                                                id="pdf-container"
                                                style={{
                                                    width: "99%",
                                                    height: "80vh",       // keeps it scrollable inside card
                                                    overflowY: "auto",    // ✅ allow auto scrollbar (not forced scroll)
                                                    WebkitOverflowScrolling: "touch", // ✅ smooth scroll (mobile too)
                                                    background: '#f5f5f5'
                                                }}
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default RulesRegulations;
